// extracted by mini-css-extract-plugin
export default {"container":"CompanyConfiguration_container__IW4CK","card-content":"CompanyConfiguration_card-content__TTQCb"};